/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
/**
 * Get MCQ Status Service
 * This service is used to get list of assignments by courseId
 * @file GetMCQStatusService.js
 * @author Satyaki Bose
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';
import { transformCourseAggregateMCQResponse } from '../utils/BerlinMCQAdapter';

export default class GetMCQStatusService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.GET_MCQ_STATUS_REQUESTED, 'getMCQStatus');
  }

  /**
   * API call for Get MCQ Status
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { userId, courseId } = eventData;

    return this.getClient('marinV2').get(`/aet/users/${userId}/courses/${courseId}/mcqs`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response) {
    // eslint-disable-next-line no-underscore-dangle
    const { data } = response;

    const mcqStore = Framework.getStoreRegistry().getStore('mcqAssignments');
    if (mcqStore && data) {
      mcqStore.setStatusData(data);
      mcqStore.resetAssignmentMCQs();
      const transformedData = transformCourseAggregateMCQResponse(response);
      mcqStore.setAssignmentMCQs(transformedData);
    }

    Framework.getEventManager().publish(AET_STORE_EVENTS.GET_MCQ_STATUS_COMPLETED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    const mcqStore = Framework.getStoreRegistry().getStore('mcqAssignments');
    if (mcqStore) {
      mcqStore.resetAssignmentMCQs();
    }
    Framework.getEventManager().publish(AET_STORE_EVENTS.ASSIGNMENT_GET_FAILED, error);
  }
}
